export const CFG = {
  breakpoint: 768,
};
